export default {
	"standard": "Стандартный отчет",
	"management": "ТЭИ: Управленческий потенциал",
	"full": "Полный отчет",
	"empty": "Для исследования",
	"references": "Эталонный профиль",
	"trajectory": "Траектории"
}